module.exports = "/assets/Inter-Regular.e148c4a1.woff";